// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppProvider } from './AppContext'; // Importa el nuevo contexto
import RecargarSaldo from './components/RecargarSaldo';
import Login from './components/Login';
import Register from './components/Register';
import PaymentGateway from './components/PaymentGateway';
import Salida from './components/Salida';
import Verification from './components/verification';
import HomePage from './components/HomePage';

import DownloadTextPage from './components/DownloadTextPage';
import MiTrabajo from './components/mi-trabajo';
import MyCV from './components/mycv';
import Services from './components/services';

ReactDOM.render(
  <Router>
    <AppProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        
        <Route path="/downloadtextpage" element={<DownloadTextPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/recargar" element={<RecargarSaldo />} />
        <Route path="/paymentgateway" element={<PaymentGateway />} />
        <Route path="/salida" element={<Salida />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/mi-trabajo" element={<MiTrabajo />} />
        <Route path="/mycv" element={<MyCV />} />
        <Route path="/services" element={<Services />} />
        <Route index element={<HomePage />} />
      </Routes>
    </AppProvider>
  </Router>,
  document.getElementById('root')
);

